<script setup lang="ts">
  import Button from "primevue/button"
  import InputText from "primevue/inputtext";
  import {ref} from "vue";

  const email = ref<string>("")
</script>

<template>
  <div class="flex flex-col max-w-96 w-full p-6">
    <InputText v-model="email" placeholder="Your email" fluid size="large" class="mb-6" />
    <Button label="Keep me informed" />
  </div>
</template>